
// functions = get<NomeFunzione>
import dayjs from 'dayjs';

import { fetchCities, fetchResevation, sendCheckinData } from './api';

export const getCities = async (value) => {
  if (value.length < 2) return [];
  const res = await fetchCities(value);
  return res.map(item => ({
    text: `${item.comune} (${item.provincia})`,
    value: item
  }));
};

export const getReservationData = async (bookingData, nations) => {
  const res = await fetchResevation({
    tipo: bookingData.type,
    codice: bookingData.type === 'codice' ? bookingData.code : '',
    dataPrenotazione: bookingData.type === 'codice' ? getFormattedDate(bookingData.date) : '',
    nome: bookingData.type === 'voucher' ? bookingData.name : '',
    cognome: bookingData.type === 'voucher' ? bookingData.surname : '',
    voucher: bookingData.type === 'voucher' ? bookingData.code : ''
  });
  if (!res || Object.keys(res).length === 0) return res;

  return {
    reservation: {
      bookingId: res.prenotazione_id,
      pickupLocation: res.localita_ritiro ? res.localita_ritiro.codice : '',
      pickupDate: new Date(res.data_ritiro),
    },
    customer: {
      id: res.anagrafica.cliente,
      companyName: res.anagrafica.ragione_sociale,
      name: res.anagrafica.nome,
      surname: res.anagrafica.cognome,
      gender: res.anagrafica.sesso,
      birthNation: getNationCode(nations, res.anagrafica.nazione_nascita),
      birthDate: res.anagrafica.data_nascita ? new Date(res.anagrafica.data_nascita) : null,
      birthCity: res.anagrafica.citta_nascita,
      birthProvince: res.anagrafica.provincia_nascita,
      taxCode: res.anagrafica.codice_fiscale,
      vatNumber: res.anagrafica.partita_iva,

      nation: getNationCode(nations, res.anagrafica.nazione),
      city: res.anagrafica.citta,
      province: res.anagrafica.provincia,
      zipCode: res.anagrafica.cap,
      address: res.anagrafica.indirizzo,
      streetNumber: res.anagrafica.civico,

      phone: res.anagrafica.telefono1,
      mobile: res.anagrafica.cellulare,
      email: res.anagrafica.email,
      pec: res.anagrafica.pec,
      SDICode: res.anagrafica.codice_sdi,

      licenseNumber: res.anagrafica.patente_numero,
      licenseCategory: res.anagrafica.patente_categoria,
      licenseIssuedBy: res.anagrafica.patente_rilasciata_da,
      licenseReleaseDate: res.anagrafica.patente_data_rilascio ? new Date(res.anagrafica.patente_data_rilascio) : null,
      licenseExpirationDate: res.anagrafica.patente_data_scadenza ? new Date(res.anagrafica.patente_data_scadenza) : null,

      documentType: res.anagrafica.documento_tipo,
      documentNumber: res.anagrafica.documento_numero,
      documentIssuedBy: res.anagrafica.documento_rilasciato_da,
      documentReleaseDate: res.anagrafica.documento_data_rilascio ? new Date(res.anagrafica.documento_data_rilascio) : null,
      documentExpirationDate: res.anagrafica.documento_data_scadenza ? new Date(res.anagrafica.documento_data_scadenza) : null,
    }
  };
};

export const getCheckinResponse = async (checkinData) => {
  const personaFisica = ['sole-proprietorship', 'individual'].includes(checkinData.customerData.type);
  return await sendCheckinData({
    prenotazioneId: String(checkinData.reservationData.bookingId),
    localitaRitiro: checkinData.reservationData.pickupLocation,

    codice: checkinData.bookingData.type === 'codice' ? checkinData.bookingData.code : '',
    dataPrenotazione: checkinData.bookingData.type === 'codice' ? getFormattedDate(checkinData.bookingData.date) : '',
    voucher: checkinData.bookingData.type === 'voucher' ? checkinData.bookingData.code : '',
    nome: checkinData.bookingData.type === 'voucher' ? checkinData.bookingData.name : '',
    cognome: checkinData.bookingData.type === 'voucher' ? checkinData.bookingData.surname : '',
    note: checkinData.bookingData.notes,

    privacyMarketing: checkinData.privacyPreferences.marketingConsent ? '1' : '0',
    privacyProfilazione: checkinData.privacyPreferences.profilingConsent ? '1' : '0',

    clienteConducente: checkinData.customerData.isDriver ? '1' : '0',

    anagrafica: {
      cliente: String(checkinData.customerData.id),
      dittaIndividuale: checkinData.customerData.type === 'sole-proprietorship' ? '1' : '0',
      personaFisica: personaFisica ? '1' : '0',

      ragioneSociale: ['sole-proprietorship', 'company'].includes(checkinData.customerData.type) ? checkinData.customerData.companyName : '',
      nome: personaFisica ? checkinData.customerData.name : '',
      cognome: personaFisica ? checkinData.customerData.surname : '',
      sesso: personaFisica ? checkinData.customerData.gender : '',
      dataNascita: personaFisica ? getFormattedDate(checkinData.customerData.birthDate) : '',
      nazioneNascita: personaFisica ? checkinData.customerData.birthNation : '',
      cittaNascita: personaFisica ? checkinData.customerData.birthCity : '',
      provinciaNascita: personaFisica ? (isItalia(checkinData.customerData.birthNation) ? checkinData.customerData.birthProvince : 'EE') : '',

      nazione: checkinData.customerData.nation,
      citta: checkinData.customerData.city,
      provincia: isItalia(checkinData.customerData.nation) ? checkinData.customerData.province : 'EE',
      cap: checkinData.customerData.zipCode,
      indirizzo: checkinData.customerData.address,
      civico: checkinData.customerData.streetNumber,
      codiceFiscale: checkinData.customerData.taxCode,
      partitaIva: checkinData.customerData.vatNumber,

      telefono1: checkinData.customerData.phone,
      email: checkinData.customerData.email,
      pec: checkinData.customerData.pec,
      codiceSdi: checkinData.customerData.SDICode,

      patenteNumero: checkinData.customerData.licenseNumber,
      patenteCategoria: checkinData.customerData.licenseCategory,
      patenteRilasciataDa: checkinData.customerData.licenseIssuedBy,
      patenteDataRilascio: getFormattedDate(checkinData.customerData.licenseReleaseDate),
      patenteDataScadenza: getFormattedDate(checkinData.customerData.licenseExpirationDate),

      documentoTipo: checkinData.customerData.documentType,
      documentoNumero: checkinData.customerData.documentNumber,
      documentoRilasciatoDa: checkinData.customerData.documentIssuedBy,
      documentoDataRilascio: getFormattedDate(checkinData.customerData.documentReleaseDate),
      documentoDataScadenza: getFormattedDate(checkinData.customerData.documentExpirationDate)
    },

    conducenti: checkinData.additionalDrivers.map(driver => ({
      cliente: '',
      dittaIndividuale: '0',
      personaFisica: '1',

      nome: driver.name,
      cognome: driver.surname,
      nazioneNascita: driver.birthNation,
      sesso: driver.gender,
      dataNascita: getFormattedDate(driver.birthDate),
      cittaNascita: driver.birthCity,
      provinciaNascita: isItalia(driver.birthNation) ? driver.birthProvince : 'EE',

      nazione: driver.nation,
      citta: driver.city,
      provincia: isItalia(driver.nation) ? driver.province : 'EE',
      cap: driver.zipCode,
      indirizzo: driver.address,
      civico: driver.streetNumber,
      codiceFiscale: driver.taxCode,
      partitaIva: '',

      telefono1: driver.phone,
      email: driver.email,

      patenteNumero: driver.licenseNumber,
      patenteCategoria: driver.licenseCategory,
      patenteRilasciataDa: driver.licenseIssuedBy,
      patenteDataRilascio: getFormattedDate(driver.licenseReleaseDate),
      patenteDataScadenza: getFormattedDate(driver.licenseExpirationDate),

      documentoTipo: driver.documentType,
      documentoNumero: driver.documentNumber,
      documentoRilasciatoDa: driver.documentIssuedBy,
      documentoDataRilascio: getFormattedDate(driver.documentReleaseDate),
      documentoDataScadenza: getFormattedDate(driver.documentExpirationDate)
    }))
  });
}

export const getTextLink = (text) => {
  return text.match(/{{(.*?)}}/)[1];
}

export const getTextNoLink = (text) => {
  return text.split(/{{.*?}}/);
}

export const getFormattedDate = (date) => {
  return date ? dayjs(date).format('YYYY-MM-DD') : '';
};

export const scrollToTop = () => {
  if ('scrollTo' in window) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  else {
    document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const getNationCode = (nations, nation) => {
  if (!nation) return;
  const nationObj = nations.find(item => item.text.toUpperCase() === nation.toUpperCase());
  return (nationObj ? nationObj.value : nation).toUpperCase();
}

const isItalia = (nation) => {
  return nation === 'ITALIA';
}